import { render, staticRenderFns } from "./QuestionLayout.vue?vue&type=template&id=88db8a64&scoped=true&"
import script from "./QuestionLayout.vue?vue&type=script&lang=js&"
export * from "./QuestionLayout.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLayout.vue?vue&type=style&index=0&id=88db8a64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88db8a64",
  null
  
)

export default component.exports